import { contactsService } from './contacts/contacts';
import { contactCompanyService } from './contacts/company';
import { employeesService } from './employees/employees';
import { employeeScheduleService } from './employees/schedules';
import { employeePlanService } from './employees/plans';
import { employeeOverridesService } from './employees/overrides';
import { ibanService } from './iban';
import { acquisitionSourceService } from './acquisition_source';
import { serviceServices } from './services';
import { serviceGroupService } from './service_groups';
import { serviceCategoriesService } from './service_categories';
import { orderStatusesService } from './order_statuses';
import { ordersService } from './orders/orders';
import { chargesService } from './orders/charges';
import { orderEmployeeService } from './orders/employees';
import { invoicesService } from './orders/invoices';
import { paymentsService } from './orders/payments';
import { bookingsService } from './booking';
import { addressesService } from './address';
import { companiesService } from './companies/company';
import { viesService } from './companies/vies';
import { companyContactService } from './companies/contact';
import { tenantCompaniesService } from './companies/tenant';
import { clientConfigurationService } from './client_configuration';
import { erganiServices } from './ergani';
import { leadsService } from './leads';
import { tenantsService } from './tenants/tenant';
import { communicationsService } from './communications';
import { branchesService } from './branches';
import { invoicingSeriesService } from './invoicing_series';
import { invoicingConfigService } from './invoicing_config';
import { adminTenantsService } from './admin/tenants';

// Define functions to call the endpoints
const apiService = {
  contacts: {
    ...contactsService,
    companies: { ...contactCompanyService },
  },
  employees: {
    ...employeesService,
    schedules: {
      ...employeeScheduleService,
      plans: { ...employeePlanService },
      overrides: { ...employeeOverridesService },
    },
  },
  ...ibanService,
  ...acquisitionSourceService,
  ...serviceServices,
  ...serviceGroupService,
  serviceCategories: {
    ...serviceCategoriesService,
  },
  ...orderStatusesService,
  orders: {
    ...ordersService,
    charges: { ...chargesService },
    employees: { ...orderEmployeeService },
    invoices: { ...invoicesService },
    payments: { ...paymentsService },
  },
  bookings: {
    ...bookingsService,
  },
  ergani: {
    ...erganiServices,
  },
  ...addressesService,
  companies: {
    ...companiesService,
    vies: { ...viesService },
    contacts: { ...companyContactService },
    tenant: { ...tenantCompaniesService },
  },
  clientConfiguration: {
    ...clientConfigurationService,
  },
  leads: {
    ...leadsService,
  },
  tenants: {
    ...tenantsService,
  },
  admin: {
    tenants: { ...adminTenantsService },
  },
  communications: {
    ...communicationsService,
  },
  branches: {
    ...branchesService,
  },
  invoicingSeries: {
    ...invoicingSeriesService,
  },
  invoicingConfig: {
    ...invoicingConfigService,
  },
};

export default apiService;
